// extracted by mini-css-extract-plugin
export var root = "_681d3a8dcadc38f85de02ade24509bf3-css";